import Restful from '../utils/restful.js'
import http from '../utils/http.js'
const project = 'sci/'

const journal = new Restful(project, 'journal')

journal.webGet = function(data) {
  const url = project + 'journal/website/query'
  return http.get(url, data).then(res => {
    return res
  })
}
journal.webQuery = function(name, data) {
  const url = project + 'journal/website/' + name
  return http.get(url, data).then(res => {
    return res
  })
}
journal.userGet = function(data) {
  const url = project + 'journal/user'
  return http.get(url, data).then(res => {
    return res
  })
}
journal.reviewerGet = function(data) {
  const url = project + 'journal/reviewer/user'
  return http.get(url, data).then(res => {
    return res
  })
}
journal.addFirst = function(data) {
  const url = project + 'journal/first'
  return http.post(url, data).then(res => {
    return res
  })
}
journal.allName = function(data) {
  const url = project + 'journal/name'
  return http.get(url, data).then(res => {
    return res
  })
}

// 期刊的学科/合作伙伴展示
journal.display = function(data) {
  const url = project + 'journal/display'
  return http.get(url, data).then(res => {
    return res
  })
}
journal.disEdit = function(data) {
  const url = project + 'journal/display'
  return http.put(url, data).then(res => {
    return res
  })
}

// 修改是否可以投稿
journal.submited = function(data) {
  const url = project + 'journal/submited'
  return http.put(url, data).then(res => {
    return res
  })
}

export default journal
